// extracted by mini-css-extract-plugin
export default {"modalContainer":"MediacionModal_modalContainer__FVS6-","modal":"MediacionModal_modal__aRxVt","closeModal":"MediacionModal_closeModal__zZ8-V"};